export const  getURLParameters = (sURL: string) => 
{
    const result = {};

    if (sURL?.indexOf("?") > 0)
    {
        var arrParams = sURL.split("?");
        var arrURLParams = arrParams[1].split("&");

        for (let i = 0; i < arrURLParams.length; ++i)
        {
            const splittedParams = arrURLParams[i].split("=");
            result[splittedParams[0]] = splittedParams[1];
        }
    }
    return result;
}